/// <reference path="../env.d.ts" />

export const environment = {
  production: true,
  api: process.env.NG_APP_API,
  url: process.env.NG_APP_URL
}
